import { downloadBlobAsFile } from '@/utils/utils';

export function downloadBlob(blob: Blob, fileName: string): void {
  downloadBlobAsFile(blob, fileName);
}

/** Метка BOM добавлена намеренно: без неё Excel в Windows показывает кириллицу нечитаемой */
export function downloadTextAsFile(text: string, fileName: string): void {
  const bom = '﻿';
  const blob = new Blob([bom + text], { type: 'text/plain;charset=utf-8' });

  downloadBlobAsFile(blob, fileName);
}

export function buildExportFileName(prefix: string, tradingName: string | null, extension: string): string {
  const date = new Date();
  const pad = (value: number) => (value < 10 ? '0' + String(value) : String(value));
  const stamp =
    String(date.getFullYear()) +
    pad(date.getMonth() + 1) +
    pad(date.getDate()) +
    '_' +
    pad(date.getHours()) +
    pad(date.getMinutes()) +
    pad(date.getSeconds());

  const network = tradingName && String(tradingName).trim() !== '' ? '_' + String(tradingName).trim() : '';

  return prefix + network + '_' + stamp + extension;
}

function stripQuotes(value: string): string {
  return String(value).trim().replace(/^"|"$/g, '');
}

/** Без Access-Control-Expose-Headers заголовок с чужого домена не виден — нужно запасное имя */
export function readContentDispositionFileName(headers: any): string | null {
  if (!headers) {
    return null;
  }

  /* Регистр ключа заголовка зависит от адаптера, поэтому проверяем оба написания */
  const raw = headers['content-disposition'] || headers['Content-Disposition'];

  if (!raw) {
    return null;
  }

  const header = String(raw);
  let name: string | null = null;

  const utf8Match = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);

  if (utf8Match && utf8Match[1]) {
    const encoded = stripQuotes(utf8Match[1]);

    try {
      name = decodeURIComponent(encoded);
    } catch (e) {
      // Битая percent-последовательность: имя как есть лучше, чем сорванное скачивание
      name = encoded;
    }
  }

  if (name === null) {
    const asciiMatch = header.match(/filename\s*=\s*"?([^";]+)"?/i);

    name = asciiMatch && asciiMatch[1] ? stripQuotes(asciiMatch[1]) : null;
  }

  if (name === null) {
    return null;
  }

  const cleaned = name
    .replace(/^.*[\\/]/, '')
    .trim();

  return cleaned !== '' ? cleaned : null;
}

/** Копируем через `execCommand`: `navigator.clipboard` требует HTTPS, а часть установок на http */
export function copyTextToClipboard(text: string): boolean {
  try {
    const element = document.createElement('textarea');

    element.value = text;
    element.setAttribute('readonly', 'readonly');
    element.style.position = 'absolute';
    element.style.left = '-9999px';

    document.body.appendChild(element);
    element.select();

    const ok = document.execCommand('copy');

    document.body.removeChild(element);

    return ok;
  } catch (e) {
    return false;
  }
}
